import React from 'react';

import styled from 'styled-components';

import { Text } from 'apps/auth/components/common/Text/Text';
import { URL_IMAGES_I } from 'apps/auth/constants/UrlConstants';
import { useThemeDetector } from 'apps/auth/hooks/theme';

const Wrapper = styled.div`
    text-align: center;
`;

const QRCodeBlock = styled.div`
    border: 1px solid ${(props) => props.theme.grey_8_lc};
    border-radius: 8px;
    box-shadow: ${(props) => props.theme.shadow_grey};
    margin: 32px auto 56px;
    width: 216px;
    padding: 24px;
`;
const AppLinksContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin: 24px -12px 0;
`;
const AppLink = styled.a`
    border: 1px solid ${(props) => props.theme.grey_8_lc};
    border-radius: 6px;
    margin: 0 12px 24px;
    padding: 6px;
`;

const DownloadApp = (props) => {
    const { theme } = useThemeDetector();

    return (
        <Wrapper>
            <QRCodeBlock>
                <figure className="illustration">
                    <picture>
                        <source media="(min-width: 736px)" srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-d.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-d.png 2x`} />
                        <source srcSet={`${URL_IMAGES_I}/smart-qr-code-1x-m.png 1x, ${URL_IMAGES_I}/smart-qr-code-2x-m.png 2x`} />
                        <img alt="Scan to join PaySend" src={`${URL_IMAGES_I}/smart-qr-code-1x-m.png`} />
                    </picture>
                </figure>
            </QRCodeBlock>
            <Text size={'main'}>{props.info}</Text>
            <AppLinksContainer>
                <AppLink href={props.appleStoreLink} target="_blank">
                    <img src={`${URL_IMAGES_I}/store-apple${theme === 'dark' ? '' : '-inverted'}.svg`} alt="AppStore" />
                </AppLink>
                <AppLink href={props.googlePlayLink} target="_blank">
                    <img src={`${URL_IMAGES_I}/store-google${theme === 'dark' ? '' : '-inverted'}.svg`} alt="GoogleStore" />
                </AppLink>
                <AppLink href={props.huaweiGalleryLink} target="_blank">
                    <img src={`${URL_IMAGES_I}/store-huawei${theme === 'dark' ? '' : '-inverted'}.svg`} alt="HuaweiStore" />
                </AppLink>
            </AppLinksContainer>
        </Wrapper>
    );
};

export default DownloadApp;
